import type { AskAssistantMessage } from './types';

export const AI_ASK_RESULTS_PAGE_SIZE = 20;

export const EMPTY_ASSISTANT_MESSAGE: AskAssistantMessage = {
  role: 'assistant',
  mode: 'streaming',
  answer: '',
  sources: [],
  references: [],
  results: [],
  debug: {},
  responseType: null,
  queryToken: '',
  originalQuery: '',
  count: null,
  entityType: '',
  indexName: '',
  filters: {},
  queryFilter: [],
  idsTruncated: false,
  viewResultsError: null,
};
